import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  equipments,
  equipmentsForm,
  workorders,
  workordersForm,
  singups,
  singupsForm,
  petitions,
  petitionsForm,
  configurations,
  configurationsForm,
  repartiments,
  repartimentsForm,
  repartidors,
  repartimentsData,
  shopCarts,
  shopCartsForm,
  articles,
  invoices,
  deliveryNotes,
  deliveries,
  deliveriesForm,
  dealers,
} from "./Reducers";

export default combineReducers({
  configurations,
  configurationsForm,
  repartiments,
  repartimentsForm,
  repartidors,
  repartimentsData,
  deliveries,
  deliveriesForm,
  dealers,
  shopCarts,
  shopCartsForm,
  articles,
  invoices,
  deliveryNotes,
  petitions,
  petitionsForm,
  singups,
  singupsForm,
  workorders,
  workordersForm,
  equipments,
  equipmentsForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
});
